import { configureStore } from '@reduxjs/toolkit'
import appSlice from './appslice'
import balanceSlice from './balanceSlice'
import userSlice from './userslice'
import skinsTotalSlice from './skinTotalslice'
import rushSlice from './rushbSlice'
import openBoxAnimationControllerReducer from './openBoxAnimationControllerSlice'
const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    user: userSlice.reducer,
    balance: balanceSlice.reducer,
    skinTotal: skinsTotalSlice.reducer,
    rush: rushSlice.reducer,
    openBoxAnimationController: openBoxAnimationControllerReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
